import { useContext } from 'react';
import {
  ChatDocumentViewerContext,
  type ChatDocumentHost,
  type ChatDocumentViewerCurrent,
} from '@/providers/ChatDocumentViewerContext';

export const useChatDocumentViewer = () =>
  useContext(ChatDocumentViewerContext);

/**
 * The open document if `host` is the surface it belongs to, else null. Chat
 * surfaces read the document through this, so the AI desktop never shows the
 * companion's document (or the other way round), not even for the render in
 * which a navigation has moved on but the document has not closed yet.
 */
export const useHostedChatDocument = (
  host: ChatDocumentHost
): ChatDocumentViewerCurrent | null => {
  const { current } = useChatDocumentViewer();
  return current?.host === host ? current : null;
};
